import request from '@/http/http'
const PRE = 'api/deer/users';
const PREFIX = 'api/identity/users';

export function forgotPass(data) {
  return request({
    url: 'api/deer/account/forgot-password',
    method: 'post',
    data
  })
}

// 获取用户列表-无权限
export function getUsersSearch(query) {
  return request({
    url: PRE + "/search?" + query
  })
}

// 创建用户
export function createUser(formData) {
  return request({
    url: PRE,
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

// 获取用户列表
export function getUsers(query) {
  return request({
    url: PRE + "?" + query,
  })
}
// 获取用户详情search
export function getUserPublicDetails(id) {
  return request({
    url: PRE + "/public/" + id,
  })
}
// 获取用户详情
export function getUserDetails(id) {
  return request({
    url: PRE + "/" + id,
  })
}

// 删除用户
export function delUser(id) {
  return request({
    url: PRE + "/" + id,
    method: "delete"
  })
}
// 批量删除用户
export function delUserList(data) {
  return request({
    url: PRE + "?" + data,
    method: "delete",
  })
}

// 更新用户
export function updateUser(id, formData) {
  return request({
    url: PRE + "/" + id,
    method: "put",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

// 获取用户岗位
export function getUserJobs(id) {
  return request({
    url: PRE + "/" + id + "/jobs",
  })
}

// 更新用户岗位
export function updateUserJobs(id, data) {
  return request({
    url: PRE + "/" + id + "/update-jobs",
    method: "put",
    data
  })
}

// 创建用户岗位
export function addUserJob(id, data) {
  return request({
    url: PRE + "/" + id + "/add-job",
    method: "put",
    data
  })
}

// 移除用户岗位
export function removeUserJob(id, data) {
  return request({
    url: PRE + "/" + id + "/remove-job",
    method: "put",
    data
  })
}

// 设置主岗位
export function updateMajorJob(id, data) {
  return request({
    url: PRE + "/" + id + "/update-major-job",
    method: "put",
    data
  })
}

// 更新用户工号
export function updateEmid(id, data) {
  return request({
    url: PRE + "/" + id + "/update-emid",
    method: "put",
    data
  })
}

// 获取岗位异动记录列表
export function getChangeRecords(query) {
  return request({
    url: PRE + "/change-records",
    params: query
  })
}

// 获取岗位异动记录
export function getChangeRecord(id) {
  return request({
    url: PRE + "/change-records/" + id,
  })
}

// 获取用户组织
export function getUserOus(id) {
  return request({
    url: PREFIX + "/" + id + "/ous",
  })
}

// 获取用户职位
export function getUserPositions(id) {
  return request({
    url: PREFIX + "/" + id + "/positions",
  })
}

// 重置用户密码
export function resetPassword(id) {
  return request({
    url: PREFIX + "/reset-password/" + id,
  })
}

// 切换员工锁定状态
export function userLockout(id, data) {
  return request({
    url: PREFIX + '/lockout/' + id,
    method: 'put',
    data
  })
}

// 异动记录审核
export function changeRecordsReview(id, data) {
  return request({
    url: PRE + '/change-records/' + id + '/review',
    method: 'put',
    data
  })
}

export function changeRecordsCancel(id) {
  return request({
    url: PRE + '/change-records/' + id + '/cancel',
    method: 'put'
  })
}

// 更新用户状态 离职、转正
export function updateStatus(id, data) {
  return request({
    url: PRE + "/" + id + '/update-status',
    method: 'put',
    data
  })
}
//获取电子档案
export function getMaterials(id, query) {
  return request({
    url: PRE + '/' + id + '/materials' + query,
    method: 'get',
    // params:query
  })
}
//上传电子档案
export function uploadMaterials(id, formData) {
  return request({
    url: PRE + '/' + id + '/upload-materials',
    method: 'put',
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}
//下载电子档案
export function downloadMaterials(id, query) {
  return request({
    url: PRE + '/' + id + '/download-materials',
    params: query,
    responseType: 'blob'
  })
}
//删除电子档案
export function deleteMaterials(id, data) {
  return request({
    url: PRE + '/' + id + '/delete-materials' + data,
    method: 'delete',
  })
}
// 通过用户标识获取信息
export function getUserPublic(id) {
  return request({
    url: PRE + '/public/' + id
  })
}